import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Grid, Table } from "semantic-ui-react";
import _ from "lodash";
import ReportSummary from "./ReportSummary";
import PhysicalDescription from "./PhysicalDescription";
import AddressDetail from "./AddressDetail";
import Offenses from "./Offenses";
import AliasesDetail from "./AliasesDetail";
import PrintReportCaseHeader from "./PrintReportCaseHeader";
import { getDobDate } from "../common/DisplayDate";
import SimpleAccordionContent from "../common/SimpleAccordionContent";

class InstantCriminalReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
    this.loadData(props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  onReportIndexChanged = (currentIndex) => {
    this.changeReport(currentIndex);
    const element = document.getElementById(`inst_crim_acc_${currentIndex}`);
    element.scrollIntoView();
  };

  onReportPrint = () => {
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = true;
    });
    this.setState({ accordionIndexes });
  };

  loadData = (props) => {
    if (props.reportData !== undefined) {
      const repRecords = _.get(props.reportData, "inmateReport.record");
      const accordionIndexes = [];
      const records = [];
      _.forEach(repRecords, (rec) => {
        records.push(rec);
        accordionIndexes.push(false);
      });
      if (accordionIndexes.length > 0) accordionIndexes[0] = true;
      this.state = {
        activeIndex: 0,
        records,
        accordionIndexes,
      };
    }
  };

  handleClick = (e, index) => {
    this.changeReport(index);
  };

  changeReport = (index) => {
    const { activeIndex } = this.state;
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = false;
    });
    accordionIndexes[index] = !accordionIndexes[index];
    if (activeIndex !== index) {
      const newIndex = activeIndex === index ? -1 : index;
      this.setState({
        activeIndex: newIndex,
        accordionIndexes,
      });
    } else {
      this.setState({
        accordionIndexes,
      });
    }
  };

  render() {
    const list = [];
    let actId;
    if (this.props.reportData !== undefined) {
      actId = _.get(
        this.props.reportData,
        `${Object.keys(this.props.reportData)[0]}.log[0].actID[0]`
      );
      _.forEach(this.state.records, (record, index) => {
        let fullNameWithJurisdiction = "";
        if (record !== undefined) {
          fullNameWithJurisdiction = `${record.fullName[0]._} ${record.sourceorjurisdiction[0]._}`;
        }
        const rows = [];
        const addNode = _.get(record, `addresses[0].address[0]`);
        rows.push(
          <Table.Row
            id={`inst_crim_row_${index}`}
            key={`inst_crim_row_${index}`}
          >
            <Table.Cell>
              <PhysicalDescription node={record} {...this.props} />
              {_.get(record, "aliases[0].alias[0]") !== undefined ? (
                <AliasesDetail
                  node={record.aliases[0]}
                  dob={getDobDate(_.get(record, "fulldob[0]._", ""), {
                    userAccount: this.props.userAccount,
                    isDobValue: true,
                  })}
                />
              ) : (
                <span />
              )}
              {addNode !== undefined ? (
                <AddressDetail addNode={addNode} {...this.props} />
              ) : (
                <span />
              )}
              <Offenses
                node={_.get(record, "offenses[0]")}
                {...this.props}
                caseNumber={_.get(record, "caseNumber[0]")}
                countyorjurisdiction={_.get(record, "countyorjurisdiction[0]")}
              />
            </Table.Cell>
          </Table.Row>
        );
        list.push(
          <SimpleAccordionContent
            {...this.props}
            name={fullNameWithJurisdiction}
            rows={rows}
            key={`inst_crim_acc_${index}`}
            accId={`inst_crim_acc_${index}`}
          />
        );
      });
    }
    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>
                  <PrintReportCaseHeader
                    {...this.props}
                    actId={actId}
                    onReportPrint={this.onReportPrint}
                  />
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <ReportSummary
                onReportIndexChanged={this.onReportIndexChanged}
                records={this.state.records}
                activeSummaryIndex={this.state.activeIndex}
              />
            </Grid.Column>
            <Grid.Column width={12}>{list}</Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(InstantCriminalReport);



// WEBPACK FOOTER //
// ./src/components/reports/InstantCriminalReport.js